<template>
  <div>
    <div v-for="brand in brands" v-if="serviceList(brand.id).length"
      :class="{'collapsible':true, 'collapse':collapsed.indexOf(brand.id) > -1}">
      <div class="heading" @click="toggleBrand(brand.id)">
        <i class="fa fa-plus-circle" v-if="collapsed.indexOf(brand.id) > -1"></i>
        <i class="fa fa-minus-circle" v-else></i>
        <span>{{ brand.name }}</span>
      </div>

      <div class="content">
        <ul :class="{'disabled':!editEnabled}">
          <li v-for="service in serviceList(brand.id)" @click="toggleService(service.id)">
            <i :class="['fa-lg', selectedService.indexOf(service.id) > -1 ? 'fa-check-square fas' : 'far fa-square' ]"></i>
            {{service.label}}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
/* global CONFIG */
import services from '@/modules/api/services'
import ApiProvider from '@/modules/api/provider/user-info'

export default {
  name: 'services',
  props: ['_licenseType'],
  data () {
    return {
      dataLoading: false,
      selectedService: [],
      licenseType: '',
      collapsed: [],
      loading: false,
      original: []
    }
  },
  computed: {
    brands () { return this.$store.state.brands.list },
    accountType () { return this.$store.state.provider.accountType.type },
    serviceSaving () { return this.$store.state.provider.serviceSave.loading },
    editEnabled () { return this.$store.state.session.user.access.hasOwnProperty('PageAdminProviderEdit') }
  },
  methods: {
    getBrands () {
      let self = this
      if (!self.$store.state.brands.list.length) {
        self.dataLoading = true
        self.$sdk.get('/brand', {}, res => {
          if (res.error) {
            return
          }

          if (res.length) {
            self.$store.commit('brands/setList', res)
            if (!self.$store.state.services.list.length) {
              self.getServices()
              return
            }
            self.dataLoading = false
          }
        })
      } else {
        self.getServices()
      }
    },
    getServices () {
      let self = this
      self.dataLoading = true
      services.getAllService(self, r => {
        self.dataLoading = false
      })
    },
    getCheckedServices () {
      let self = this
      self.selectedService = []
      self.$sdk.get('/provider/' + self.$route.params.id + '/services', {
        token: self.$store.state.session.sessionToken,
        order: 'priority'
      }, res => {
        if (!res.error) {
          self.original = []
          res.list.forEach(service => {
            self.original.push(service)
            if (service.enabled && self.selectedService.indexOf(service.service.id) === -1) {
              self.selectedService.push(service.service.id)
              if (service.service.id === CONFIG.serviceId.doorToDoor) {
                self.$store.commit('provider/setIsDoorToDoorEnabled', true)
              }
            }
          })
        }
      }, '2.0')
    },
    serviceList (brandId) { 
      if (this.licenseType === 'tnc') {
        return this.$store.state.services.list.filter(x => x.brandId === brandId && x.allowTNC)
      }
      if (this.licenseType === 'tcp') {
        return this.$store.state.services.list.filter(x => x.brandId === brandId && x.allowTCP)
      }
      if (this.licenseType === 'psc') {
        return this.$store.state.services.list.filter(x => x.brandId === brandId && x.allowPSC)
      }
      return []
    },
    toggleBrand (id) {
      if (this.collapsed.indexOf(id) > -1) {
        let index = this.collapsed.indexOf(id)
        this.collapsed.splice(index, 1)
      } else {
        this.collapsed.push(id)
      }
    },
    toggleService (serviceId) {
      if (!this.editEnabled) { return }
      if (this.selectedService.indexOf(serviceId) > -1) {
        let index = this.selectedService.indexOf(serviceId)
        this.selectedService.splice(index, 1)
        if (serviceId === CONFIG.serviceId.doorToDoor) {
          this.$store.commit('provider/setIsDoorToDoorEnabled', false)
        }
      } else {
        this.selectedService.push(serviceId)
        if (serviceId === CONFIG.serviceId.doorToDoor) {
          this.$store.commit('provider/setIsDoorToDoorEnabled', true)
        }
      }
    },
    save () {
      let self = this
      let services = []

      if (self.serviceSaving) { return }

      self.brands.forEach(brand => {
        let serviceList = []
        if (this.licenseType === 'tnc') {
          serviceList = this.$store.state.services.list.filter(x => x.brandId === brand.id && x.allowTNC)
        } else if (this.licenseType === 'tcp') {
          serviceList = this.$store.state.services.list.filter(x => x.brandId === brand.id && x.allowTCP)
        } else if (this.licenseType === 'psc') {
          serviceList = this.$store.state.services.list.filter(x => x.brandId === brand.id && x.allowPSC)
        }
        serviceList.forEach(service => {
          let index = self.original.findIndex(x => x.service.id === service.id)
          if (index > -1 && self.original[index].enabled !== self.selectedService.indexOf(service.id) > -1) {
            services.push({
              id: service.id,
              enabled: self.selectedService.indexOf(service.id) > -1
            })
          }
        })
      })

      self.$store.commit('provider/setServiceSaveLoading', true)
      ApiProvider.updateProviderServices(self, {
        id: self.$route.params.id,
        services: services
      }, res => {
        self.$store.commit('provider/setServiceSaveLoading', false)
        self.$store.commit('provider/serviceSaveModal', true)

        let response = {
          success: true,
          message: ''
        }
        if (res.error) {
          response = {
            success: false,
            message: res.error.message
          }
        }

        if (!res.error) {
          services.forEach(service => {
            let index = self.original.findIndex(x => x.service.id === service.id)
            self.original[index].enabled = service.enabled
          })
          if (!services.length) {
            response.message = 'No changes to provider service types.'
          }
        }
        self.$store.commit('provider/serviceSaveSuccess', response)
      })
    }
  },
  watch: {
    '_licenseType': function (value) {
      this.licenseType = value
    }
  },
  mounted () {
    this.getBrands()
    this.getCheckedServices()
  }
}
</script>

<style lang="scss" scoped>
$cta-link: #0D79F2;

.collapsible{
  margin-bottom: 5px;

  .heading{
    color: $cta-link;
    margin-bottom: 2px;
    cursor: pointer;
    text-transform: uppercase;

    i{ margin-right: 5px; }
    span { font-weight: 600; }
  }
  .content{
    margin-left: 6px;
    padding: 5px 0 5px 15px;
    border-left: 2px solid #ddd;
    max-height: 700px; /* define precise max-height for more smoother transition */
    height: auto;
    transition:all 0.35s ease-out;

    ul{
      list-style: none;
      background: #fff;
      padding: 10px;
      margin: 0;
      -webkit-column-count: 2;
      -moz-column-count: 2;
      column-count: 2;
      column-gap: 5px;

      li{
        padding: 3px 10px;
        font-size: 13px;
        cursor: pointer;

        &:hover{ background: #fafafa; }
        i{
          margin-right: 5px;
          color: #57d1b7;
        }
      }
      &.disabled {
        li { cursor: default; }
        li:hover{ background: #fff; }
      }
    }
  }
  &.collapse .content{
    max-height: 0;
    overflow: hidden;
    padding: 0 15px;
  }
}

@media only screen and (max-width: 430px) {
  .collapsible {
    .content {
      padding: 5px 0 5px 5px;
      ul {
        padding: 0;
        li {
          padding: 5px 3px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Provider/Services.vue